/**
 * Conditional Access Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ValidateReason = 0 | 1 | 2;

export const ValidateReason = {
    NUMBER_0: 0 as ValidateReason,
    NUMBER_1: 1 as ValidateReason,
    NUMBER_2: 2 as ValidateReason
};

